
export default {

	// 接口域名
	baseUrl: '/api/v1',

	baseUrlPro: 'https://api.emisenv.com:5226/api/v1'
}